import React from "react";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import useSnackbar from "../../../hooks/useSnackbar";
import AgGridPaginatedTable from "../../../components/AgGridPaginatedTable";
import {
  PaymentAppliedTable,
  PaymentCreditTable,
  PaymentDepositTable,
} from "../../../config/grid-column-defs";
import { getTransactionCustomerDeposit,getTransactionCredit ,getTransactionApplied} from "../../../api/transaction-type";
import { slugMap } from "../../../config/slug-config";
import { useParams } from "react-router-dom";
import {
  Box,
  Tabs,
  Tab,Grid
} from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import TabPanel from "../../../components/TabPanel";


export default function PaymentApply() {
  const [tabIndex, setTabIndex] = useState(0);
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const pageDetail = slugMap[params.slug];
  const [rowData, setRowData] = useState([]);
  const [creditSum,setCreditSum] = useState("")
  const [depositSum,setDepositSum] = useState("")

  async function getTransactionDepositData(limit, offset) {
    setLoading(true);
    try {
      const { data } = await getTransactionCustomerDeposit(user.token, {
        id: params.docNo,
        limit,
        offset
      });
      setDepositSum(data.data);
      setLoading(false);
      return {
        rows: data.data.data,
        total: data.data.total,
        error: false,
      };
    } catch (error) {
      console.log(error);
      setLoading(false);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      setLoading(false);
    }
  }

  async function getTransactionAppliedData(limit, offset) {
    setLoading(true);
    try {
      const { data } = await getTransactionApplied(user.token, {
        id: params.docNo,
        limit,
        offset
      });
      setRowData(data.data);
      setLoading(false);
      return {
        rows: data.data.data,
        total: data.data.total,
        error: false,
      };
    } catch (error) {
      console.log(error);
      setLoading(false);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      setLoading(false);
    }
  }
  async function getTransactionCreditData(limit, offset) {
    setLoading(true);
    try {
      const { data } = await getTransactionCredit(user.token, {
        id: params.docNo,
        limit,
        offset
      });
      setCreditSum(data.data);
      setLoading(false);
      return {
        rows: data.data.data,
        total: data.data.total,
        error: false,
      };
    } catch (error) {
      console.log(error);
      setLoading(false);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      setLoading(false);
    }
  }
  return (
    <>
      <Box className="viewDetilsBox">
      <Box className="viewDetilsBox">
              <Grid container>
                <Grid item xs={12} sm={6}>
                  <p className="tFormlabel">PAYMENT AMOUNT</p>
                  <p className="tFormName">{rowData?.paymentamount}</p>
                </Grid>
              </Grid>
            </Box>
        <Tabs
          value={tabIndex}
          // onChange={handleChange}
          onChange={(e, nv) => {
            setTabIndex(nv);
          }}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
          className="tabs-sub-bkg"
        >
          <Tab label={`Applied To ${rowData?.sum||""}`} />
          <Tab label={`Credits Applied ${creditSum?.sum || ""}`} />
          <Tab label={`Deposits Applied ${depositSum?.sum || ""}`} />
        </Tabs>
        {/*----------Messages------------*/}
        <TabPanel value={tabIndex} index={0}>
          <AgGridPaginatedTable
            getTableRows={getTransactionAppliedData}
            columns={PaymentAppliedTable}
            refreshCounter={0}
          />
        </TabPanel>
        <TabPanel value={tabIndex} index={1}>
         <AgGridPaginatedTable
            getTableRows={getTransactionCreditData}
            columns={PaymentCreditTable}
            refreshCounter={0}
          />
        </TabPanel>
        <TabPanel value={tabIndex} index={2}>
       <AgGridPaginatedTable
            getTableRows={getTransactionDepositData}
            columns={PaymentDepositTable}
            refreshCounter={0}
          />
        </TabPanel>
      </Box>
    </>
  );
}
